import { useEffect } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import ListItemButton from '@mui/material/ListItemButton';
import React from "react"
import { usePathname, useRouter } from 'src/routes/hooks';
import { RouterLink } from 'src/routes/components';

import { useResponsive } from 'src/hooks/use-responsive';
import Scrollbar from 'src/components/scrollbar';
import { NAV } from './config-layout';
import navConfig from './config-navigation';
import { useSelector, useDispatch } from 'react-redux';
import { auth } from 'src/config/firebase';


export default function Nav({ openNav, onCloseNav }) {
  const { user } = useSelector((state) => state.auth);
  const { login } = useResponsive((state) => state.auth)
  const router = useRouter();
  console.log("user", user);

  const pathname = usePathname();
  const upLg = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const renderAccount = () => {
    return (
      <Box
        sx={{
          my: 3,
          mx: 2.5,
          p: 2,
          px: 2.5,
          display: 'flex',
          borderRadius: 1.5,
          alignItems: 'center',
          bgcolor: (theme) => alpha(theme.palette.grey[500], 0.12),
        }}
      >
        {/* <Avatar alt="photoURL" /> */}
        <Box sx={{ ml: 2 }} alignItems={"flex-start"} display={'flex'} flexDirection={'column'} width={"100%"}>
          <Typography variant="subtitle2" >{user?.full_name}</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {user?.email}
          </Typography>
          <Button onClick={confirmLogout} style={{ backgroundColor: "#8B19A4", color: "white", height: 35, width: "100%", marginTop: 10 }}>
            Logout
          </Button>
        </Box>
      </Box>
    )
  }

  const renderMenu = (
    <>
      <Stack component="nav" spacing={0.5} sx={{ px: 1, mt: 3 }}>
        {navConfig.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </Stack>

      {/* <Stack component="nav" spacing={0.5} sx={{ px: 2, py: 2 }} >
          <ListItemButton
            component={RouterLink}
            sx={{
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(pathname === '/profile' && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
            <AccountPopover />
          </ListItemButton>
        </Stack> */}
    </>
  );
  const confirmLogout = () => {
    localStorage.clear();
    window.location.reload();
    router.push('/');
    auth.signOut();
  };


  const renderUpgrade = (
    <Stack alignItems="center" spacing={3} sx={{ pt: 5, borderRadius: 2, position: 'relative' }}>
      <Box sx={{ textAlign: 'center' }} width={"100%"}>
        {renderAccount()}
      </Box>
    </Stack>
  );

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box display={"flex"} justifyContent={"center"} style={{ marginTop: "10px" }}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/logo.png`}
          alt=""
          style={{ width: "58%" }}
        />
      </Box>
      {renderMenu}
      <Box sx={{ flexGrow: 1 }} />
      {renderUpgrade}
    </Scrollbar>
  );

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.WIDTH },
        backgroundColor: "white"
      }}
    >
      {upLg ? (
        <Box
          sx={{
            height: 1,
            position: 'fixed',
            width: NAV.WIDTH,
            borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          }}
        >
          {renderContent}
        </Box>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.WIDTH,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

// ----------------------------------------------------------------------

function NavItem({ item }) {
  const pathname = usePathname();
  const active = item.path === pathname;

  return (
    <ListItemButton
      component={RouterLink}
      href={item.path}
      sx={{
        minHeight: 44,
        borderRadius: 0.05,
        typography: 'body2',
        color: 'text.secondary',
        textTransform: 'capitalize',
        fontWeight: 'fontWeightMedium',
        ...(active && {
          color: 'primary.main',
          fontWeight: 'fontWeightSemiBold',
          // backgroundColor: "#FE6910",
          // '&:hover': "#FE6910",
          borderRadius: "8px",
          // border: "1px solid #FE6910"
          bgcolor: (theme) => alpha(theme.palette.grey[500], 0.12),

        }),
      }}
    >
      <Box component="span" sx={{ width: 24, height: 24, mr: 2 }}>
        {item.icon}
      </Box>

      <Box component="span">{item.title} </Box>
    </ListItemButton>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
};